import { useStytchMember } from "@stytch/react/b2b";

/**
 * Checks if the current user is an administrator. This is a front-end only check,
 * permissions MUST also be checked on the server.
 *
 * @returns true if the currently logged in user has an admin role; false otherwise.
 */
export function useIsAdmin(): boolean {
    const { member } = useStytchMember();
    return member?.roles.find((r) => r.role_id === "stytch_admin") !== undefined;
}
